import type { ReactNode } from "react";
import { Alert } from "antd";
import limitReachedIcon from "../../assets/icons/Livello_3.svg?url";
import "./CustomSharedLimitReachedAlert.css";

interface CustomSharedLimitReachedAlertProps {
  title: ReactNode;
  description: ReactNode;
  className?: string;
}

const CustomSharedLimitReachedAlert = ({
  title,
  description,
  className,
}: CustomSharedLimitReachedAlertProps) => (
  <Alert
    className={`custom-shared-limit-reached-alert ${className ?? ""}`.trim()}
    type="warning"
    showIcon
    icon={<img src={limitReachedIcon} alt="" />}
    closable
    message={title}
    description={description}
  />
);

export default CustomSharedLimitReachedAlert;
